import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a17fadf5209d55739facdb0907aa71fb5b from "./generated-7fd3e96c-6b4d-4b97-ba98-8927569d4f40.json";

import af67b1816e8932416463d6fdc628e2946b from "./generated-727c0581-9cb5-4e5e-a18d-d792eedf6449.json";

import a5f0c8911e0a6c58b71164be884856c5eb from "./generated-a99972c3-db6d-4a3a-9815-64fff6ea4c82.json";

import a8e042420a12c50244ae67c62e5a7a7acb from "./generated-8ca53672-ed6a-4e4c-affa-48264bbd8ba3.json";

import ab9bf0a2ef7d43d5f532f988d3fafd02eb from "./generated-1a0b640e-f2dd-4ff0-9bd3-519117b2aa7b.json";

import ac177724b6c9b207a9fd559d50e9ba76bb from "./generated-c956e75b-7f13-49f5-abb8-b18db163845d.json";

import a7f21125181da8e741f7e8f24c2f1452eb from "./generated-1d882c5f-e3d8-4ede-973d-f71697af72c6.json";

import a59256c8a1d7f52183ff242f338e22521b from "./generated-0e8618b3-ac31-4141-99b1-bbfdeebb5188.json";

import a0e326d854dfe7763619f96c20607bc37b from "./generated-9829d295-a5a6-45df-aa72-45ae9a24b1b4.json";

import a161454c735b82a2ccf333e85871130aeb from "./generated-45905e84-257b-403d-a3a2-7b0ab3af4dc9.json";

import a6ce53f4e12f9826ab0428359e0030998b from "./generated-00a38acf-9bce-483b-b46f-e45f4f46112b.json";

import a921789499ee2ce10a89ed9add338c940b from "./generated-d2a60631-a92a-44bc-9a93-e8962ffd891e.json";

import a255e3b0a3cd96cbaf169851e87216e2eb from "./generated-8dd2eddd-8dbb-4d6a-91e5-9c06de49e964.json";

import a4ca9691009f9106a6cfe0c12ba5978a3b from "./generated-b987864e-10b6-4ae2-9a84-615d7b2b39e6.json";

import a4cd158ac13224120762f0c04ef5233beb from "./generated-0ebeed12-4385-4f8a-9ae7-4acd9b44e749.json";

import a81b426787f69fd3553380d8ddf1d616bb from "./generated-e10097dd-c790-4d86-aa86-e455f1022498.json";

import a5424156ecc5daa35de70de0f3b0d0b89b from "./generated-b0f78a10-b3a9-4b2f-8524-08ba9bf529b9.json";

import a1deb27e6b907bb1dccad8f9548592f1ab from "./generated-9e1aeebc-d656-4409-8e7b-824dd9876040.json";

import ace1c9ff48d3fb5498c0b1212af7124f7b from "./generated-bde5b14c-b16d-4ceb-9c71-b7e83848bc1e.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a17fadf5209d55739facdb0907aa71fb5b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(af67b1816e8932416463d6fdc628e2946b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a5f0c8911e0a6c58b71164be884856c5eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a8e042420a12c50244ae67c62e5a7a7acb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ab9bf0a2ef7d43d5f532f988d3fafd02eb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ac177724b6c9b207a9fd559d50e9ba76bb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a7f21125181da8e741f7e8f24c2f1452eb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a59256c8a1d7f52183ff242f338e22521b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a0e326d854dfe7763619f96c20607bc37b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a161454c735b82a2ccf333e85871130aeb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6ce53f4e12f9826ab0428359e0030998b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a921789499ee2ce10a89ed9add338c940b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a255e3b0a3cd96cbaf169851e87216e2eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a4ca9691009f9106a6cfe0c12ba5978a3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a4cd158ac13224120762f0c04ef5233beb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a81b426787f69fd3553380d8ddf1d616bb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a5424156ecc5daa35de70de0f3b0d0b89b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a1deb27e6b907bb1dccad8f9548592f1ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ace1c9ff48d3fb5498c0b1212af7124f7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a5424156ecc5daa35de70de0f3b0d0b89b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */